document.addEventListener('DOMContentLoaded', function () {
  const desc = document.querySelector('.description-block .metafield-rich_text_field');
  const el = document.querySelector('[data-charecter-count]');

  if (!desc) return;

  const fullText = desc.innerHTML.trim();
  const maxLength = el.dataset.charecterCount;

  if (fullText.length <= maxLength) return;

  const shortText = fullText.substring(0, maxLength);
  let expanded = false;

  desc.innerHTML = `${shortText}<span id="dots">... </span><a id="toggleBtn" style="color:#000; font-weight:600; cursor:pointer;">Read more</a>`;

  desc.addEventListener('click', function (event) {
    if (event.target && event.target.id === 'toggleBtn') {
      expanded = !expanded;
      if (expanded) {
        desc.innerHTML = `${fullText} <a id="toggleBtn" style="color:#000; font-weight:600; cursor:pointer;">Read less</a>`;
      } else {
        desc.innerHTML = `${shortText}<span id="dots">... </span><a id="toggleBtn" style="color:#000; font-weight:600; cursor:pointer;">Read more</a>`;
      }
    }
  });
});